import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6d6f3b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer_input" }
const _hoisted_2 = { class: "input-fields" }
const _hoisted_3 = { class: "input-fields-wrapper" }
const _hoisted_4 = { class: "input-fields-wrapper" }
const _hoisted_5 = { class: "input-fields-wrapper" }

import CustomInputField from "../generics/CustomInputField.vue";
import { useBookingStore, order } from "@/store/bookingStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerInputSummaryBlock',
  setup(__props) {

const bookingStore = useBookingStore();

function handle_paye_input(event: any, key_name: keyof order) {
  bookingStore.order[key_name as keyof order] = event;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CustomInputField, {
          id: "name",
          class: "input-field",
          label: "Förnamn",
          initValue: _unref(bookingStore).order.firstname,
          onOnInput: _cache[0] || (_cache[0] = ($event: any) => (handle_paye_input($event, 'firstname')))
        }, null, 8, ["initValue"]),
        _createVNode(CustomInputField, {
          id: "surname",
          class: "input-field",
          label: "Efternamn",
          initValue: _unref(bookingStore).order.surname,
          onOnInput: _cache[1] || (_cache[1] = ($event: any) => (handle_paye_input($event, 'surname')))
        }, null, 8, ["initValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CustomInputField, {
          id: "adress",
          class: "input-field",
          label: "Adress",
          initValue: _unref(bookingStore).order.adress,
          onOnInput: _cache[2] || (_cache[2] = ($event: any) => (handle_paye_input($event, 'adress')))
        }, null, 8, ["initValue"]),
        _createVNode(CustomInputField, {
          id: "city",
          class: "input-field",
          label: "Ort",
          initValue: _unref(bookingStore).order.city,
          onOnInput: _cache[3] || (_cache[3] = ($event: any) => (handle_paye_input($event, 'city')))
        }, null, 8, ["initValue"]),
        _createVNode(CustomInputField, {
          id: "postalnr",
          class: "input-field",
          label: "Postnummer",
          initValue: _unref(bookingStore).order.postalNumber,
          onOnInput: _cache[4] || (_cache[4] = ($event: any) => (handle_paye_input($event, 'postalNumber')))
        }, null, 8, ["initValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CustomInputField, {
          id: "phonenr",
          class: "input-field",
          label: "Telefonnummer",
          initValue: _unref(bookingStore).order.phoneNumber,
          onOnInput: _cache[5] || (_cache[5] = ($event: any) => (handle_paye_input($event, 'phoneNumber')))
        }, null, 8, ["initValue"]),
        _createVNode(CustomInputField, {
          id: "email",
          class: "input-field",
          label: "Email",
          initValue: _unref(bookingStore).order.email,
          onOnInput: _cache[6] || (_cache[6] = ($event: any) => (handle_paye_input($event, 'email')))
        }, null, 8, ["initValue"])
      ])
    ])
  ]))
}
}

})